import type { ReactNode } from "react";

/**
 * Small util transformer gracefully copied over from Contentful docs
 * @see https://github.com/contentful/rich-text/tree/master/packages/rich-text-react-renderer
 */
export const deserializeLineBreaks = (text: string) =>
  text
    .split("\n")
    .reduce((children: ReactNode[], textSegment: string, index: number) => {
      return [...children, index > 0 && <br key={index} />, textSegment];
    }, []);
